import { uploadApi } from "./axios";
import { STORAGE_ENDPOINTS } from "./endpoints";

export function uploadCertificates(payload) {
  return uploadApi.post(STORAGE_ENDPOINTS.UPLOAD_CERTIFICATES, payload);
}

export function uploadAchievements(payload) {
  return uploadApi.post(STORAGE_ENDPOINTS.UPLOAD_ACHIEVEMENTS, payload);
}

export function uploadIdentification(payload) {
  return uploadApi.post(STORAGE_ENDPOINTS.UPLOAD_IDENTIFICATION, payload);
}

export function uploadProfileImage(payload) {
  return uploadApi.post(STORAGE_ENDPOINTS.UPLOAD_PROFILE_IMAGE, payload);
}

export async function generateSignedUrl(filePath) {
  const res = await uploadApi.get(`${STORAGE_ENDPOINTS.GET_SIGNED_URL}?filePath=${encodeURIComponent(filePath)}`); 
  return res.data.url;
}
export async function generateSignePublicdUrl(filePath) {
  const res = await uploadApi.get(`${STORAGE_ENDPOINTS.GET_SIGNED_PUBLIC_URL}?filePath=${encodeURIComponent(filePath)}`); 
  return res.data;
}
